/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Script from 'next/script';
import { StyleProvider, ToastProvider, useDidMount, useIsomorphicLayoutEffect } from '@mtsbank/ui-kit';
import '../index.css';
// TODO: по какой-то причине стили для тултипа из ui-kit
// не попадают в билд из коробки.
// Вероятно нужны допилы в настройки билда некста, пока не разобрался
import 'tippy.js/index.css';
import '../../public/fonts/stylesheet.css';
import { gtmNoScript, gtmScript } from '@utils/gtm/gtmScript';
// import { RouteGuard } from '@components/RouteGuard/RouteGuard'
// import { INSTANA_SCRIPT, INSTANA_SCRIPT_URL } from '@root/utils/instanaScript'
import { IB_SERVICE_URL } from '@root/constants';
import { BreadCrumbsProvider } from '@root/components/Breadcrumbs/BreadCrumbsProvider';
import { CyberLayout } from '@root/components/CyberLayout/CyberLayout';
import { authHelper } from '@root/utils/authHelper/AuthHelper';
import useAuthDataStore from '@store/useAuthDataStore';
import useBindingsStore from '@store/useBindingsStore';
import { gibInit } from '@root/utils/groupIBService';
import { usePreviousRoute } from '@root/hooks/usePreviousRoute';
const serviceInfo = {
  name: 'МТС Оплата',
  title: 'Оплата игровых кошельков: пополнение аккаунтов онлайн банковской картой',
  description: 'Пополнение игровых кошельков  ⏩ Онлайн оплата подписки банковской картой ⏩ Удобный сервис для быстрых переводов и платежей'
};
const App = ({
  Component,
  pageProps
}) => {
  const {
    setIsAuth,
    isAuth,
    setUserData,
    fetchProfile,
    operatorMTS,
    paymentBanMTS,
    errorOperatorInfo,
    mtsData,
    setMtsData
  } = useAuthDataStore();
  const {
    isNeedUpdateBindings,
    fetchBindings
  } = useBindingsStore();
  const {
    servicesForSearch
  } = pageProps;
  const [isGibInit, setIsGibInit] = useState(false);
  usePreviousRoute();
  useDidMount(() => {
    gibInit(setIsGibInit);
  });
  useEffect(() => {
    if (isAuth && !mtsData && isGibInit) {
      authHelper.initMtsToken(setMtsData);
    }
  }, [isAuth, mtsData, setMtsData, isGibInit]);
  useEffect(() => {
    if (isAuth && mtsData?.phone) {
      fetchProfile();
    }
  }, [isAuth, mtsData, setMtsData, fetchProfile]);
  useEffect(() => {
    if (isAuth) {
      if (isNeedUpdateBindings &&
      // profileStatus === 'success' &&
      // profile?.error?.code !== 225 &&
      operatorMTS && !paymentBanMTS && !errorOperatorInfo) {
        fetchBindings();
      }
      if (isGibInit && window.gib) {
        window.gib.setAuthStatus(window.gib.IS_AUTHORIZED);
      }
    }
  }, [fetchProfile, fetchBindings, isAuth, isNeedUpdateBindings, operatorMTS, isGibInit, paymentBanMTS, errorOperatorInfo]);
  useIsomorphicLayoutEffect(() => {
    authHelper.initialize();
    if (authHelper.isAuthenticated()) {
      setIsAuth(true);
      setUserData(authHelper.userData);
    }
  }, []);
  return <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>{serviceInfo.title}</title>
        <meta name="description" content={serviceInfo.description} />
        <link rel="apple-touch-icon" sizes="57x57" href="/cyber/favicons/apple-icon-57x57.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="/cyber/favicons/apple-icon-60x60.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="/cyber/favicons/apple-icon-72x72.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="/cyber/favicons/apple-icon-76x76.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="/cyber/favicons/apple-icon-114x114.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="/cyber/favicons/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="/cyber/favicons/apple-icon-144x144.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="/cyber/favicons/apple-icon-152x152.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/cyber/favicons/apple-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="/cyber/favicons/android-icon-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/cyber/favicons/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="/cyber/favicons/favicon-96x96.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/cyber/favicons/favicon-16x16.png" />
        <link rel="manifest" href="/cyber/favicons/manifest.json" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
        <script defer src={IB_SERVICE_URL} />
      </Head>
      <StyleProvider>
        <ToastProvider>
          <BreadCrumbsProvider>
            <CyberLayout servicesForSearch={servicesForSearch}>
              <Component {...pageProps} />
            </CyberLayout>
          </BreadCrumbsProvider>
        </ToastProvider>
      </StyleProvider>

      {/* <Script id="instana" dangerouslySetInnerHTML={{ __html: INSTANA_SCRIPT }} /> */}
      {/* <Script defer crossOrigin="anonymous" src={INSTANA_SCRIPT_URL} /> */}

      <Script defer id="gtm-src" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: gtmScript
    }} />

      <noscript dangerouslySetInnerHTML={{
      __html: gtmNoScript
    }} />
    </>;
};
export default App;